import { render } from "./UserPersonalData.vue?vue&type=template&id=e8f8f21a&scoped=true&ts=true"
import script from "./UserPersonalData.vue?vue&type=script&lang=ts"
export * from "./UserPersonalData.vue?vue&type=script&lang=ts"

import "./UserPersonalData.vue?vue&type=style&index=0&id=e8f8f21a&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\mobileApp\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e8f8f21a"]])

export default __exports__